import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { FaSpinner } from 'react-icons/fa';
import CheckoutForm from './CheckoutForm'; // Composant pour gérer le formulaire
import './Paiement.css'; // Importation du style

// Chargez la clé publique Stripe depuis les variables d'environnement
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Paiement = () => {
  const location = useLocation();
  const { total } = location.state || {}; // Récupérer le total depuis ResumeCommande.js
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    if (!total) {
      console.error('Montant manquant pour le paiement');
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL || 'https://skaneat-app.vercel.app';
    
    // Appel à votre backend pour obtenir le clientSecret
    fetch(`${apiUrl}/create-payment-intent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: total }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erreur HTTP: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.clientSecret) {
          setClientSecret(data.clientSecret);
        } else {
          throw new Error('Client secret manquant dans la réponse');
        }
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération du clientSecret :', error);
        // Ici vous pourriez afficher un message d'erreur à l'utilisateur
      });
  }, [total]);

  const appearance = { theme: 'stripe' };
  const options = { clientSecret, appearance };

  return (
    <div className="payment-page">
      {clientSecret ? (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm total={total} clientSecret={clientSecret} />
        </Elements>
      ) : (
        <div className="loading-container">
          <div className="loading-card">
            <FaSpinner className="loading-icon spinning" />
            <p>Préparation du paiement...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Paiement;
